import { render, staticRenderFns } from "./SelectSpacePath.vue?vue&type=template&id=c2444404&scoped=true&"
import script from "./SelectSpacePath.vue?vue&type=script&lang=ts&"
export * from "./SelectSpacePath.vue?vue&type=script&lang=ts&"
import style0 from "./SelectSpacePath.vue?vue&type=style&index=0&id=c2444404&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2444404",
  null
  
)

export default component.exports